import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-24 sm:pt-32 pb-10 sm:pb-16 px-4 min-h-[80vh] sm:min-h-[90vh] flex items-center overflow-hidden" data-id="element-57">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-red/10 rounded-full blur-[120px] pointer-events-none" data-id="element-58" />

      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-60">
          <h1 className="text-4xl sm:text-6xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-[1.1] text-shadow-lg" data-id="element-61">
            THEY WANTED HIS SILENCE.
            <br data-id="element-62" />
            <span className="text-brand-red" data-id="element-63">
              THE WORLD GOT A DIGITAL MANIFESTO.
            </span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-64">
          <h2 className="text-lg sm:text-2xl md:text-3xl font-lora font-medium text-gray-300 mb-5 sm:mb-8 max-w-3xl mx-auto leading-relaxed normal-case" data-id="element-65">
            Download TODAY the untold story of Charlie Kirk: The young man who
            defied the elites, woke up a generation, and left a legacy that
            lives on every screen.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mb-6 sm:mb-10 w-full max-w-xs sm:max-w-md mx-auto" data-id="element-66">
          <img src="https://cdn.magicpatterns.com/uploads/qpipCnjok1ZwFiBxR8ETu4/MCK-3.png" alt="Voices of Freedom Book Cover" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(196,30,58,0.3)]" data-id="element-67" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="w-full flex flex-col items-center" data-id="element-68">
          <p className="text-brand-gold font-oswald text-base sm:text-xl mb-4 sm:mb-6 max-w-2xl mx-auto tracking-wide" data-id="element-69">
            The Definitive Chronicle: "Voices of Freedom" — Now available in
            digital format so you can carry the torch of freedom in your pocket.
          </p>
          <CTAButton scrollTo="pricing" data-id="element-70">GET INSTANT ACCESS NOW</CTAButton>
        </motion.div>
      </div>
    </section>;
}